/** Reception-queue roles share the same tab layout and search visibility (AXISREF349/350). */
export function normalizeRole(role: string | null | undefined): string {
  return (role || '').toLowerCase();
}

export function isReceptionQueueRole(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r === 'reception' || r === 'receptionist' || r === 'pa';
}

/** Roles that can access the referral queue page (mirrors NonClinicianRoute in App.tsx). */
export function isQueuePageRole(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r !== '' && r !== 'clinician' && r !== 'pending';
}

/** Roles that see Ready / Missing Information tabs on the queue page. */
export function isPersonalQueueTabRole(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r === 'manager' || r === 'viewer';
}

/** Roles that can use nav quick search and My/All cross-queue search on the referral queue. */
export function isCrossQueueSearchRole(role: string | null | undefined): boolean {
  return isQueuePageRole(role);
}
